import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'message-info-item',
	templateUrl: 'message-info-item.html'
})
export class MessageInfoItemComponent {

	@Input("item") item = {};
	@Input('currentUser') currentUser = {};

	@Output('onClick') onClick: EventEmitter<any> = new EventEmitter()

	constructor() {

	}

}



// WEBPACK FOOTER //
// ./src/components/message-info-item/message-info-item.ts